import React from 'react'
import { UiGetCustomer, documentation as UiGetCustomerDoc } from "./uiGetCustomer";
import { UiAddFieldEntity, documentation as UiAddFieldEntityDoc } from './uiAddFieldEntity';
import StepManager from '../components/stepManager';
import { Redirect } from 'react-router-dom';
import { renderReport } from '../components/elementList';

let documentation = {
    title: 'Assign Field', 
    subtitle: 'Add Field EntityView assigned to chosen customer.',
    brief: 'Creates an existing field EntityView to be assigned to a chosen customer.',
    content: <p><p><b>The purpose of this feature is to make a field data visible through multiple customers.</b></p>
        Choosing a customer and a Field, will be created the Fields EntityViews and associated to
        the chosen customer accounts. An EntityView per customer-type is created and associated to its customer on type-base.
        The <i>Contains relation</i> between each EntityView and the customer is created too.</p>,
    steps:[
        { id: 0, ...UiGetCustomerDoc },
        { id: 1, ...UiAddFieldEntityDoc },
    ]
};

class UiAssignField extends React.Component {

    static defaultProps = {
        title: 'Assign Field'
    };
    constructor(props) {
        super(props);
        this.stepManagerRef = React.createRef();
        this.state = {
            finished: false,
            nextRoute: this.props.nextRoute,
            dashboardName: '',

            customer: { name: '', agronomist: null, operator: null },
            field: { data: null, report: null },

        };
    }

    documentation = (title) => {
        if (!title) { return documentation; }

        let doc = documentation;
        documentation.title = title;
        return doc;
    }

    stepManagerAdvance = () => {
        const element = this.stepManagerRef.current;
        element.advance();
    };

    renderGetCustomerForm = () => {
        return (
            <UiGetCustomer
                error={this.handleSubmitError}
                services={{ customer: this.props.services.customer }}
                finished={(report) => {
                    this.setState({ customer: report });
                    this.stepManagerAdvance();
                }}
            />
        );
    };

    renderFieldForm = () => {
        return (
            <UiAddFieldEntity
                title='Add Field Entity'
                services={{
                    asset: this.props.services.asset,
                    customer: this.props.services.customer
                }}
                customer={this.state.customer}
                finished={(fieldData, report) => {
                    this.setState({ field: { data: fieldData, report: report } });
                    this.stepManagerAdvance();
                }}
            />
        );
    };

    render() {
        let documentation = this.documentation(this.props.title);
        let { field } = this.state;

        return (
            <div className="container-fluid">
                {this.state.finished && <Redirect to={this.state.nextRoute} />}
                <StepManager ref={this.stepManagerRef}
                    startStepId={0} endStepId={1}
                    onFinished={() => {
                        //window.open( this.props.links.thingsboardRoutes.dashboards );
                        this.setState({ finished: true });
                        this.stepManagerAdvance();
                    }}
                    stepList={[
                        { stepId: 0, stepName: documentation.steps[0].title, formValue: this.renderGetCustomerForm, 
                            documentation: documentation.steps[0]},
                        {
                            stepId: 1, stepName: documentation.steps[1].title, formValue: this.renderFieldForm,
                            dataValue: () => renderReport(field.report), documentation: documentation.steps[1]
                        },
                    ]}
                    documentation={documentation}
                />
            </div>
        );
    }
}


export default UiAssignField;
export {UiAssignField, documentation}